/**
 * TanStack-Query-Keys für Firma-Verwaltung + Property-Zuweisungen (C3).
 * Zentral gehalten, damit Invalidation nach Mutationen konsistent bleibt.
 */
export const companyKeys = {
  all: ['companies'] as const,
  lists: () => [...companyKeys.all, 'list'] as const,
  list: (filters: object) => [...companyKeys.lists(), filters] as const,
  detail: (id: string) => [...companyKeys.all, 'detail', id] as const,
};

export const assignmentKeys = {
  all: ['property-assignments'] as const,
  list: (filter: { propertyId?: string; userId?: string; companyId?: string }) =>
    [...assignmentKeys.all, 'list', filter] as const,
};
